import type { StorageSummary } from "../types/app";
import { formatBytes, requestPersistentStorage } from "../storage/storageEstimate";

interface Props {
  summary: StorageSummary | null;
  onRefresh: () => void;
}

export function StoragePanel({ summary, onRefresh }: Props) {
  return (
    <section className="notice">
      <strong>端末内ストレージ</strong>
      <p>
        使用量 {formatBytes(summary?.usage ?? 0)} / 概算上限 {formatBytes(summary?.quota ?? 0)}
        {summary?.persisted === true ? "。永続保存が許可されています。" : "。永続保存は保証されていません。"}
      </p>
      <p>ブラウザデータ削除、PWA削除、OSのストレージ整理でIndexedDBの会話、記憶、設定、画像、動画、音声サンプルは失われる可能性があります。</p>
      <button
        type="button"
        onClick={async () => {
          await requestPersistentStorage();
          onRefresh();
        }}
      >
        永続保存を要求
      </button>
    </section>
  );
}
